<template>
  <div
    class="AwardBadge"
    data-testid="awardBadge"
  >
    {{ award.name }}
  </div>
</template>

<script lang="ts" setup>
import { Award } from "@shared/lib/database/query.types";

const award = defineModel<Award>({
  required: true,
});
</script>

<style lang="scss" scoped>
.AwardBadge {
  --cornerSize: 4px;
  justify-self: start;
  padding: 5px 6px 3px;

  background-color: var(--colorGold);
  color: var(--colorOffBlack);

  font: var(--fontWeightMedium) 12px / 1 var(--fontFamilyNormal);
  font-stretch: var(--fontWidthExtended);

  @supports (corner-shape: scoop) {
    border-radius: var(--cornerSize);
    corner-shape: scoop;
  }

  @supports not (corner-shape: scoop) {
    mask: radial-gradient(var(--cornerSize) at top left, transparent 98%, black) top left,
      radial-gradient(var(--cornerSize) at top right, transparent 98%, black) top right,
      radial-gradient(var(--cornerSize) at bottom left, transparent 98%, black) bottom left,
      radial-gradient(var(--cornerSize) at bottom right, transparent 98%, black) bottom right;
    mask-size: 51% 51%;
    mask-repeat: no-repeat;
  }
}
</style>
